import * as React from "react";
import { Fade, InputBase, styled } from "@mui/material";
import { ErrorText } from "../numericInput";
import { PatientColorMap } from "../../../../../layout/patientColorMap";
import { forwardRef } from "react";
import { onRtl } from "fe-web-components/rtl/rtlStyles";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import clsx from "clsx";

//region [[ Styles ]]

export const NumericInputViewContainer = styled(InputBase)({
  "&.numeric-input-view input": {
    borderRadius: "3px",
    height: "100%",
    border: `1px solid ${PatientColorMap.DefaultDark}`,
    width: "auto",
    padding: "5px 12px",
    background: PatientColorMap.White,
    minWidth: "42px",
    fontSize: "16px",
    "& , &:focus, &[type=text], &[type=text]:focus": {
      flex: 1,
      textAlign: "left",
      ...onRtl({
        textAlign: "right",
      }),
      // padding: "0 7px",
      // border: "none",
      // background: "transparent",
      color: KahunColorMap.BlackPatientFacing,
    },
  },
  ".blood-pressure-input &.numeric-input-view input": {
    padding: "14px",
    width: "100%",
    minWidth: "90px",
    "& , &:focus, &[type=text], &[type=text]:focus": {
      textAlign: "center",
      // Beat the rtl right alignment
      ...onRtl({
        textAlign: "center",
      }),
    },
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface NumericInputViewProps {
  className?: string;
  value: number | string;
  onChange: (e) => void;
  placeholder?: string;
  errorText?: string;
  onEnter?: () => void;
  endAdornment?: JSX.Element;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const NumericInputView = React.memo(
  forwardRef(({ onEnter, onChange, ...props }: NumericInputViewProps, ref) => {
    const handleInputValueChange = (e) => {
      onChange(e.target.value && e.target.value !== "" ? e.target.value : "");
    };

    const handleKeyDown = (e): void => {
      if (onEnter && e.key === "Enter") {
        onEnter();
      }
    };

    const selectAllText = (e) => {
      e?.target?.select?.();
    };

    return (
      <>
        <NumericInputViewContainer
          className={clsx("numeric-input-view", props.className)}
          ref={ref}
          value={props.value || ""}
          onChange={handleInputValueChange}
          placeholder={props.placeholder}
          inputProps={{ inputMode: "decimal" }}
          endAdornment={props.endAdornment}
          onKeyDown={handleKeyDown}
          onClick={selectAllText}
        />
        <Fade in={!!props.errorText} mountOnEnter unmountOnExit>
          <ErrorText>{props.errorText}</ErrorText>
        </Fade>
      </>
    );
  }),
);
